import { lazy } from 'react';

const AdvanceDetails = lazy(() => import('./details'));

export { Advances } from './list';

export { AdvanceDetails };
